/**************************************************
 * Nombre:
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../Tema";
import {useNavigate} from "react-router-dom";
import img_def from '../../Recursos/img_defecto.png'

const Tarjeta_Ultimos_Detalle = ({item}) => {
    const navegate = useNavigate()

    return (
        <Grid
            onClick={() => navegate('/Detalle/' + item.id)}
            container
            justifyContent={'flex-start'}
            alignItems={'center'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: '#FFF',
                strokeWidth: 0.5,
                stroke: 'rgba(0, 0, 0, 0.10)',
                filter: 'drop-shadow(0px 2px 20px rgba(0, 0, 0, 0.10))',
                p: 1,
                borderRadius: 1.5,
                cursor: 'pointer'
            }}>

            <Grid container size={{xs: 3, sm: 3, md: 3}}>

                <img src={item.img ? item.img : img_def} width={'100%'} style={{borderRadius: 4}}/>

            </Grid>

            <Grid container size={{xs: 9, sm: 9, md: 9}} sx={{paddingLeft: 2}}>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography variant="body2"
                                sx={{
                                    color: theme.palette.primary.main, fontSize: 14,
                                    fontWeight: 600,
                                }}>
                        {item.marca}
                    </Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography variant="body2"
                                sx={{
                                    color: theme.palette.text.primary,
                                    fontSize: 16,
                                    lineHeight: 1.1,
                                    fontWeight: 600,
                                }}>
                        {item.nombre}
                    </Typography>
                </Grid>


            </Grid>
        </Grid>
    )

}
export default Tarjeta_Ultimos_Detalle;